import React, { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import TabsContext from '../context/tabs-context';
import TabNonSwipeableArea from '../components/tab-non-swipeable-area';

const TabNonSwipeableAreaContainer = ({ children }) => {
  const { disableSwipeableContent, setSwipePrevented } = useContext(TabsContext);

  if (disableSwipeableContent) {
    return <Fragment>{children}</Fragment>;
  }

  const handleOnTouchStart = () => {
    setSwipePrevented(true);
  };

  const handleOnTouchEnd = () => {
    setSwipePrevented(false);
  };

  return (
    <TabNonSwipeableArea onTouchStart={handleOnTouchStart} onTouchEnd={handleOnTouchEnd}>
      {children}
    </TabNonSwipeableArea>
  );
};

TabNonSwipeableAreaContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TabNonSwipeableAreaContainer;
